import { render, staticRenderFns } from "./GroupDashboard.vue?vue&type=template&id=c38a96cc"
import script from "./GroupDashboard.vue?vue&type=script&lang=ts"
export * from "./GroupDashboard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports